import React from "react";
import ReactSelect, { type FilterOptionOption, type SingleValue } from "react-select";
import { ChevronDown } from "lucide-react";
import { type Option, selectStyles } from "./selectStyles";
import { normalize } from "@/lib/utils";

export interface SearchableOption extends Option {
    description?: string;
}

interface SearchableSelectProps {
    options: SearchableOption[];
    value: SearchableOption | null;
    onChange: (value: string) => void;
    placeholder?: string;
}

export const SearchableSelect: React.FC<SearchableSelectProps> = (
    {
        options,
        value,
        onChange,
        placeholder,
    }) => {
    return (
        <ReactSelect<SearchableOption, false>
            options={options}
            value={value}
            onChange={(opt: SingleValue<SearchableOption>) => opt && onChange(opt.value)}
            placeholder={placeholder}
            noOptionsMessage={() => "Aucune contrainte"}
            filterOption={(opt: FilterOptionOption<SearchableOption>, input: string) => {
                const q = normalize(input);
                return (
                    normalize(opt.label).includes(q) ||
                    normalize(opt.data.description ?? "").includes(q)
                );
            }}
            styles={selectStyles}
            components={{
                DropdownIndicator: () => (
                    <div className="p-1.5 text-gray-400">
                        <ChevronDown className="w-4 h-4"/>
                    </div>
                )
            }}
        />
    );
};
